import { render, staticRenderFns } from "./SelectWorkflowProcesso.vue?vue&type=template&id=6636fb8c&scoped=true"
import script from "./SelectWorkflowProcesso.vue?vue&type=script&lang=js"
export * from "./SelectWorkflowProcesso.vue?vue&type=script&lang=js"
import style0 from "./SelectWorkflowProcesso.vue?vue&type=style&index=0&id=6636fb8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6636fb8c",
  null
  
)

export default component.exports